/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Views_Builtin_All_OpenInputs */

const en_views_builtin_all_open = /** @type {(inputs: Views_Builtin_All_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All open`)
};

const de_views_builtin_all_open = /** @type {(inputs: Views_Builtin_All_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle offenen`)
};

/**
* | output |
* | --- |
* | "All open" |
*
* @param {Views_Builtin_All_OpenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views_builtin_all_open = /** @type {((inputs?: Views_Builtin_All_OpenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Views_Builtin_All_OpenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_views_builtin_all_open(inputs)
	return en_views_builtin_all_open(inputs)
});